import React, { FC } from 'react';
import { EVALUATION_OVERALL_STATUSES } from '../../types/ComplianceChecklistTypes';
import {
	EVALUATION_OVERALL_STATUS_COLORS,
	EVALUATION_OVERALL_STATUS_DISPLAY_NAMES,
} from './ComplianceConstants';

interface ComplianceEvaluationStatusDisplayProps {
	// Derived overall status (deriveOverallEvaluationStatus), not a value the
	// model returns.
	status: string;
	style?: React.CSSProperties;
}

// Pill for the derived verdict of an AI evaluation, following the same shape as
// the other status displays in the app.
export const ComplianceEvaluationStatusDisplay: FC<ComplianceEvaluationStatusDisplayProps> = ({
	status,
	style = {},
}): React.ReactElement => {
	if (!status || !Object.keys(EVALUATION_OVERALL_STATUSES).includes(status)) {
		return null;
	}
	const statusColor = EVALUATION_OVERALL_STATUS_COLORS[status];
	return (
		<span
			className="footnoteregular"
			style={{
				color: statusColor,
				border: `1px solid ${statusColor}`,
				padding: '2px 10px',
				borderRadius: 16,
				whiteSpace: 'nowrap',
				...style,
			}}
		>
			{EVALUATION_OVERALL_STATUS_DISPLAY_NAMES[status]}
		</span>
	);
};
